import { environment } from './../../../../environments/environment';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'defaultUserFullUrl',
    standalone: false
})
export class DefaultUserFullUrlPipe implements PipeTransform {
    transform(data, type): string {
        if (data) {
            return environment.systemUrl + data;
        }
        else {
            switch (type) {
                case "image":
                    return "./assets/img/users/default-user.jpg";
                case "audio":
                    return "./assets/img/empty.mp3";
                case "video":
                    return "./assets/img/empty.mp4";
            }
        }
        return null;
    }
}